<kendo-grid [data]="profileService.extraElements" style="height: 100%;"
	kendoGridSelectBy="id" [(selectedKeys)]="selectedKeys" (selectionChange)="choseOption($event)">
	<kendo-grid-column field="name" [title]="nameColumnTitle">
	</kendo-grid-column>
	<kendo-grid-column field="quantity" [title]="quantityColumnTitle">
	</kendo-grid-column>
</kendo-grid>